import React, { Component } from "react";
import { connect } from "react-redux";

const ROLE_STYLES = {
  Admin:     { bg: "#F3F0FF", color: "#6C63FF", border: "#DDD6FE" },
  Accounts:  { bg: "#FEFCE8", color: "#A16207", border: "#FDE68A" },
  Officer:   { bg: "#F0FDF4", color: "#15803D", border: "#BBF7D0" },
  Employee:  { bg: "#FFF7ED", color: "#C2410C", border: "#FED7AA" },
  Partner:   { bg: "#FEF2F2", color: "#B91C1C", border: "#FECACA" },
};

const HEADERS = ["Name", "Mobile", "Email", "Role", "Active Status", ""];

export class Datatable extends Component {
  constructor(props) {
    super(props);
    this.state = { hovered: null };
  }

  render() {
    const { myData, currentAdmin, startToggleModal } = this.props;
    const { hovered } = this.state;
    const canChange = !(currentAdmin && currentAdmin.status === "Partner");

    return (
      <div style={{ overflowX: "auto" }}>
        <table style={{ width: "100%", borderCollapse: "collapse" }}>
          <thead>
            <tr style={{ background: "#F8F7FF", borderBottom: "2px solid #EEE" }}>
              {HEADERS.map((h, i) => (
                <th
                  key={i}
                  style={{
                    padding: "12px 16px",
                    color: "#6C63FF",
                    fontWeight: 600,
                    fontSize: 13,
                    textAlign: i === HEADERS.length - 1 ? "center" : "left",
                    whiteSpace: "nowrap",
                  }}
                >
                  {h}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {(!myData || myData.length === 0) && (
              <tr>
                <td
                  colSpan={HEADERS.length}
                  style={{ padding: 32, textAlign: "center", color: "#AAA", fontSize: 14 }}
                >
                  No admins found
                </td>
              </tr>
            )}
            {(myData || []).map((admin) => {
              const initial = admin.name ? admin.name.charAt(0).toUpperCase() : "?";
              const roleStyle = ROLE_STYLES[admin.status] || { bg: "#F3F4F6", color: "#6B7280", border: "#E5E7EB" };
              const isActive = !admin.activeStatus || admin.activeStatus === "Active";
              const isHovered = hovered === admin.adminId;

              return (
                <tr
                  key={admin.adminId}
                  style={{
                    borderBottom: "1px solid #F3F3F3",
                    background: isHovered ? "#FAFBFF" : "white",
                    transition: "background 0.15s",
                  }}
                  onMouseEnter={() => this.setState({ hovered: admin.adminId })}
                  onMouseLeave={() => this.setState({ hovered: null })}
                >
                  {/* Name with avatar */}
                  <td style={{ padding: "12px 16px" }}>
                    <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                      <div
                        style={{
                          width: 36,
                          height: 36,
                          borderRadius: "50%",
                          background: "#6C63FF",
                          color: "white",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          fontWeight: 700,
                          fontSize: 14,
                          flexShrink: 0,
                        }}
                      >
                        {initial}
                      </div>
                      <span style={{ fontSize: 13, fontWeight: 600, color: "#1A1A2E" }}>
                        {admin.name || "—"}
                      </span>
                    </div>
                  </td>

                  {/* Mobile */}
                  <td style={{ padding: "12px 16px", fontSize: 13, color: "#555" }}>
                    {admin.mobileNo || "—"}
                  </td>

                  {/* Email */}
                  <td style={{ padding: "12px 16px", fontSize: 13, color: "#555" }}>
                    {admin.email || "—"}
                  </td>

                  {/* Role badge */}
                  <td style={{ padding: "12px 16px" }}>
                    <span
                      style={{
                        background: roleStyle.bg,
                        color: roleStyle.color,
                        border: `1px solid ${roleStyle.border}`,
                        borderRadius: 5,
                        padding: "3px 10px",
                        fontSize: 12,
                        fontWeight: 700,
                        whiteSpace: "nowrap",
                      }}
                    >
                      {admin.status || "—"}
                    </span>
                  </td>

                  {/* Active status */}
                  <td style={{ padding: "12px 16px" }}>
                    <span
                      style={{
                        display: "inline-flex",
                        alignItems: "center",
                        gap: 5,
                        background: isActive ? "#F0FDF4" : "#FEF2F2",
                        color: isActive ? "#15803D" : "#B91C1C",
                        border: `1px solid ${isActive ? "#BBF7D0" : "#FECACA"}`,
                        borderRadius: 5,
                        padding: "3px 10px",
                        fontSize: 12,
                        fontWeight: 600,
                        whiteSpace: "nowrap",
                      }}
                    >
                      <span
                        style={{
                          width: 6,
                          height: 6,
                          borderRadius: "50%",
                          background: isActive ? "#15803D" : "#B91C1C",
                          display: "inline-block",
                        }}
                      />
                      {isActive ? "Active" : "Inactive"}
                    </span>
                  </td>

                  {/* Change Status */}
                  <td style={{ padding: "12px 16px", textAlign: "center" }}>
                    <button
                      disabled={!canChange}
                      onClick={() => startToggleModal(admin)}
                      style={{
                        padding: "5px 14px",
                        borderRadius: 6,
                        border: "1px solid #6C63FF",
                        color: canChange ? "#6C63FF" : "#CCC",
                        background: "white",
                        cursor: canChange ? "pointer" : "not-allowed",
                        fontSize: 13,
                        fontWeight: 500,
                        whiteSpace: "nowrap",
                        borderColor: canChange ? "#6C63FF" : "#E5E7EB",
                      }}
                    >
                      Change Status
                    </button>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  currentAdmin: state.admins.currentAdmin,
});

export default connect(mapStateToProps, null)(Datatable);
